(ns ncr.reports.overview
  (:require
   [ncr.reports.grid-cell :as gc]
   [ncr.etc.patternfly-charts]
   [ncr.charts :as charts]
   [ncr.reports.explain]))

(defn- row [report paths props]
  (gc/data-row report paths props
    {:extension ncr.reports.explain/c-explain-plain}))


(defn render [report {:keys [heading]}]
  (let [row (partial row report)
        revenue {:report-path [:cashflow :revenue] :cube-path [:total] :sym-path [:income] :uniq :overview}
        costs {:report-path [:cashflow :costs] :cube-path [:total] :sym-path [:expense] :uniq :overview}
        pnl {:report-path [:cashflow :pnl] :cube-path [] :sym-path []}]
    [{:type :header
      :heading [charts/c-header-with-experimental-charts-button {:header heading :report report :paths [revenue costs pnl]}]}
     (row revenue {:heading "Revenue"})
     (row costs {:heading "Costs"})
     (row pnl {:heading "PnL" :colorize? true})]))
